import { useState, type FormEvent } from 'react';
import { ApiError } from '@hutdrop/api-client';
import logoMark from '@hutdrop/design-tokens/logo-mark.svg';
import { api } from '../lib/api';

export function LoginPage() {
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string | null>(null);

  async function onSubmit(e: FormEvent<HTMLFormElement>) {
    e.preventDefault();
    const data = new FormData(e.currentTarget);
    setBusy(true);
    setError(null);
    try {
      await api.login({ email: String(data.get('email') ?? ''), password: String(data.get('password') ?? '') });
    } catch (err) {
      setError(err instanceof ApiError ? err.message : 'Something went wrong. Please try again.');
    } finally {
      setBusy(false);
    }
  }

  return (
    <main className="login">
      <form className="login__card" onSubmit={onSubmit} noValidate>
        <div className="login__brand">
          <img src={logoMark} width={40} height={40} alt="" />
          <div>
            <p className="login__wordmark">HutDrop</p>
            <p className="login__sub">Store dashboard</p>
          </div>
        </div>
        <h1 className="login__title">Staff sign in</h1>
        {error ? (
          <p className="alert" role="alert">
            {error}
          </p>
        ) : null}
        <label className="field">
          <span>Email</span>
          <input name="email" type="email" autoComplete="username" required />
        </label>
        <label className="field">
          <span>Password</span>
          <input name="password" type="password" autoComplete="current-password" required />
        </label>
        <button className="btn btn--primary" type="submit" disabled={busy}>
          {busy ? 'Signing in…' : 'Sign in'}
        </button>
        <p className="muted small">Accounts are created by the store owner. Customers sign in on the shop site.</p>
      </form>
    </main>
  );
}
